import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core';
import { dataService } from '../../../Services/data.service';
import { toast } from 'react-toastify';
import { useTranslation } from "react-i18next";
import UserTable from '../../User/UserTable';

export default function UserOverviewPage() {

    const classes = useStyles();
    const [users, setUsers] = useState([]);
    const [roles, setRoles] = useState([]);
    const [refresh, setRefresh] = useState(false);
    const { t } = useTranslation();

    useEffect(() => {

        Promise.all([  
            dataService.getAllUsersWithDetails(parseInt()),
            dataService.getAllRoles()
        ]).then((results) => {

            let userResults = results[0];
            let roleResults = results[1];
            setUsers(userResults);
            setRoles(roleResults);

        }).catch((error) => { toast.error(error, { position: "top-center" }) });

    }, [refresh])

    const refreshUsers = () => {
        setRefresh(!refresh);
    }

    return (
        <div className={classes.userOverViewPageBackground}>
            <div className={classes.spacer80}>{t("Gebruikers")}</div>
            <div className={classes.users}>
                <UserTable refresh={refreshUsers} users={users} roles={roles}></UserTable>
            </div>
        </div>
    )
}

const useStyles = makeStyles({
    spacer80: {
        height: '50px',
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: '#000000',
        paddingLeft: "5px"
    },
    navButton: {
        textDecoration: 'none',
    },

    userOverViewPageBackground: {
        padding: "20px",
        marginTop: "55px"
    },

});

